var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',[(_vm.$hasTeam)?_c('router-view',{attrs:{"slot":"main-content"},slot:"main-content"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }